import { State, TabDisplayInterface, User } from '@wam/shared';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { map, takeUntil } from 'rxjs/operators';
import { authenticationSelectors } from '@wam/authentication';
import { isStaff } from '../authentication/user.data';

@Injectable({
  providedIn: 'root',
})
export class TeacherUsersTabDisplayService implements TabDisplayInterface, OnDestroy {
  private store = inject<Store<State>>(Store);

  private destroyed$ = new Subject<void>();

  private enabled = true;

  isFirst(): Observable<boolean> {
    return of(false);
  }

  shouldShow(): Observable<boolean> {
    return this.store.pipe(
      select(authenticationSelectors.getCurrentUser),
      map((user: User) => this.enabled && isStaff(user)),
      takeUntil(this.destroyed$),
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
